module.exports = __webpack_public_path__ + "media/images/device-phone-mobile-6aa069f0c905c1ea0aa18f84e3d20645f8689b19c8d83e0690ad2c7f4a15b6e0.svg";